import React from "react";

import TextHorizontalCard from "../cards/textHorizontalCard";

const DownloadApps = ({
  parentPackData,
  travelSmartData,
  outerContainerClass = "bg-white dark:bg-gray-standard",
  innerContainerClass = "w-11/12 md:w-10/12 md:px-6 py-20 mx-auto"
}) => {
  return (
    <>
      {(parentPackData || travelSmartData) && (
        <div className={`w-full flex ${outerContainerClass}`}>
          <div className={innerContainerClass}>
            <div className="flex flex-col md:flex-row gap-6 md:gap-3 h-auto">
              {parentPackData && <TextHorizontalCard {...parentPackData} />}
              {travelSmartData && <TextHorizontalCard {...travelSmartData} />}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DownloadApps;
